import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseServiceCause } from "../_types/case-service-cause";

@Injectable({
    providedIn: 'root',
})
export class CasesServicesCausesService extends Service<CaseServiceCause> {
    public override type = 'caseServiceCauses';
    public override url = 'attendance/caseServiceCauses';

    caseServiceCauseTypes() {
        let caseServiceCausesTypes = [
            { label: 'Cancelación', value: 'Cancel' },
            { label: 'Cita atrasada', value: 'DelayedDate' }
        ];
        return caseServiceCausesTypes;
    }

    getCaseServiceCaseTypeLabel(value: string) {
        let caseServiceCaseTypes = this.caseServiceCauseTypes();
        let caseServiceCaseType = caseServiceCaseTypes.find(x => x.value == value);
        return caseServiceCaseType?.label;
    }
}
